<template>
  <v-card outlined class="promotion-card flex-grow-1">
    <!-- Header -->
    <div class="promotion-card__header d-flex justify-space-between mb-4">
      <v-skeleton-loader type="text" width="120" height="32" />
      <div class="d-flex align-center">
        <v-skeleton-loader type="button" width="40" height="40" class="mr-1" />
        <v-skeleton-loader type="button" width="40" height="40" />
      </div>
    </div>

    <!-- Main Content Row -->
    <v-row dense class="mt-4">
      <!-- Image Column -->
      <v-col cols="12" md="3">
        <v-skeleton-loader
          type="image"
          height="180"
          class="promotion-card__image-skeleton" />
      </v-col>

      <!-- Fields Column -->
      <v-col cols="12" md="5">
        <div class="promotion-card__fields-skeleton">
          <v-skeleton-loader
            type="text"
            width="100%"
            height="40"
            class="mb-3" />
          <v-skeleton-loader
            type="text"
            width="100%"
            height="40"
            class="mb-3" />
          <div class="d-flex align-center">
            <v-skeleton-loader
              type="chip"
              width="80"
              height="40"
              class="mr-3" />
            <v-skeleton-loader type="text" width="120" height="40" />
          </div>
        </div>
      </v-col>

      <!-- Price Summary Column -->
      <v-col cols="12" md="4">
        <div class="promotion-card__price-summary-skeleton">
          <v-skeleton-loader
            type="text"
            width="100%"
            height="24"
            class="mb-2" />
          <v-skeleton-loader
            type="text"
            width="100%"
            height="24"
            class="mb-2" />
          <v-skeleton-loader type="divider" class="my-2" />
          <v-skeleton-loader
            type="text"
            width="100%"
            height="28"
            class="mt-2" />
        </div>
      </v-col>
    </v-row>

    <!-- Components Section -->
    <v-row dense class="mt-4">
      <v-col cols="12">
        <div
          class="promotion-card__components-header d-flex justify-space-between align-center">
          <v-skeleton-loader type="text" width="180" height="24" />
          <v-skeleton-loader type="button" width="140" height="36" />
        </div>

        <!-- Table Skeleton -->
        <v-simple-table class="promotion-card__components-table-skeleton">
          <thead>
            <tr>
              <th>
                <v-skeleton-loader type="text" width="100" height="20" />
              </th>
              <th class="text-center">
                <v-skeleton-loader type="text" width="60" height="20" />
              </th>
              <th class="text-center">
                <v-skeleton-loader type="text" width="60" height="20" />
              </th>
              <th class="text-center">
                <v-skeleton-loader type="text" width="80" height="20" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td :colspan="4" class="text-center">
                <v-skeleton-loader type="text" width="300" height="20" />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'PromotionSkeletonLoader',
}
</script>

<style scoped lang="scss">
.promotion-card {
  padding: 1rem;
}

.promotion-card__header {
  min-height: 2.5rem;
}

.promotion-card__image-skeleton {
  border-radius: 4px;
  border: 1px dashed rgba(0, 0, 0, 0.12);
}

.promotion-card__fields-skeleton {
  min-height: 8.75rem;
}

.promotion-card__price-summary-skeleton {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #e4e8f0;
  padding: 0.75rem 1rem;
  min-height: 7.5rem;
}

.promotion-card__components-header {
  min-height: 2.5rem;
}

.promotion-card__components-table-skeleton {
  width: 100%;
}

.promotion-card__components-table-skeleton th,
.promotion-card__components-table-skeleton td {
  border-bottom: 1px solid #d7dce6 !important;
  vertical-align: middle;
  padding: 0.5rem 0.25rem !important;
}
</style>
